module.exports = __webpack_public_path__ + "static/media/test10_2.2fe368b4.png";